import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-note",
  "use": "icon-note-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-note\">\n<path d=\"M13.5 4C12.9477 4 12.5 4.44772 12.5 5V22C12.5 20.8954 13.3954 20 14.5 20H21.5C22.0523 20 22.5 19.5523 22.5 19V5C22.5 4.44772 22.0523 4 21.5 4H13.5Z\" fill=\"black\" />\n<path d=\"M10.5 4C11.0523 4 11.5 4.44772 11.5 5V22C11.5 20.8954 10.6046 20 9.5 20H2.5C1.94771 20 1.5 19.5523 1.5 19V5C1.5 4.44772 1.94772 4 2.5 4H10.5Z\" fill=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol